import request from '@/utils/http.js';
import env, { meetingApiList, roomApiList } from '@/request/env';
import axios from 'axios/dist/axios';
import { wechatShare, wechatOaSdkSign } from "../brand/wechat.js";


// 发起端初始化
function initSendLive(params) {
  const url = meetingApiList['initSendLive']['v3'];
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 发起端云导播推流页面初始化
function initSendLiveYun(params) {
  const url = meetingApiList['initSendLiveYun']['v3'];
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 发起端获取云导播台是否有流
function getStreamStatus(params) {
  const url = meetingApiList['getStreamStatus']['v3'];
  return request({
    url,
    method: 'POST',
    data: params
  });
}

function selectSeat(params = {}) {
  return request({
    url: meetingApiList.selectSeat['v3'],
    method: 'POST',
    data: params
  });
}

// 客户端嵌入-发起端初始化
function clientEmbed(params) {
  const url = env.meeting === 'v3' ? '/v3/webinars/live/client-init' : '';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 观看端初始化（标品）
function initStandardReceiveLive(params) {
  const url = env.meeting === 'v3' ? '/v3/webinars/watch/init' : '';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 观看端初始化（嵌入页）
function initEmbeddedReceiveLive(params) {
  const url = env.meeting === 'v3' ? '/v3/webinars/watch/inline-init' : '';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 观看端初始化（SDK）
function initSdkReceiveLive(params) {
  const url = env.meeting === 'v3' ? '/v3/webinars/watch/sdk-init' : '';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

//发起端回放录制初始化
function initRecordVideo(data = {}) {
  const url = env.meeting === 'v3' ? '/v3/webinars/record/init' : '';
  return request({
    url,
    method: 'POST',
    data
  });
}


// 开始直播
function startLive(params) {
  const url = roomApiList['startLive']['v3'];

  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 开始直播-第三方
function startLiveThird(params) {
  const url = '/v3/webinars/stream/pull';

  return request({
    url,
    method: 'POST',
    data: params
  });
}


// 结束直播
function endLive(params) {
  const url = '/v3/webinars/live/end';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 开始录制
function startRecord(params) {
  const url = '/v3/webinars/record/start-record';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 结束录制
function endRecord(params) {
  const url = '/v3/webinars/record/stop-record';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 进入直播前检测
function checkLive(params) {
  const url = '/v3/webinars/live/check';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 查询活动配置信息
const getConfigList = (params = {}) => {
  return request({
    url: '/v3/users/permission/get-config-list',
    method: 'POST',
    data: params
  });
};
// 编辑活动配置信息
const editConfigList = (params = {}) => {
  return request({
    url: '/v3/users/permission/edit-webinar-config',
    method: 'POST',
    data: params
  });
};

const setDurationSwitch = (params = {}) => {
  return request({
    url: '/v3/vss/room/set-duration-switch',
    method: 'POST',
    data: params
  });
};

const restrictions = (params = {}) => {
  let url = '/v3/interacts/agreement/get-agreement'
  return request({
    url,
    method: 'GET',
    params
  })
}

// 同意观看限制
const setUserAgree = params => {
  return request({
    url: '/v3/interacts/agreement/set-user-agree',
    method: 'POST',
    data: params
  })
}

//获取活动多语言配置信息
const getLangList = (params = {}) => {
  return request({
    url: '/v3/webinars/webinar-language/get-list',
    method: 'POST',
    data: params
  });
};

// 查询活动互动状态
const getInavToolStatus = (params = {}) => {
  const url = roomApiList['getInavToolStatus']['v3'];
  return request({
    url,
    method: 'POST',
    data: params
  });
};

// 观看端聚合接口
const getCommonConfig = (params = {}) => {
  const url = '/v3/interacts/union/common-config';
  return request({
    url,
    method: 'POST',
    data: params
  });
};

// 获取聊天服务链接参数
function getChatInitOptions(params) {
  const url = '/v3/webinars/live/get-connect';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 心跳检测
function liveHeartBeat(params) {
  const url = '/v3/webinars/live/heartbeat';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 获取live_token
function getLiveToken(params) {
  const url = '/v3/webinars/live/get-live-token';
  request({
    url,
    method: 'POST',
    data: params
  });
}

// switch旁路
function switchBroadcast(params) {
  const url = roomApiList['switchBroadcast']['v3'];
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 获取推流地址
function getStreamPushAddress(params) {
  const url = '/v3/webinars/live/get-stream-push-address';
  return request({
    url,
    method: 'POST',
    data: params
  });
}
function getStreamPullAddress(params) {
  const url = '/v3/webinars/stream/get-webinar-pull-info';
  return request({
    url,
    method: 'GET',
    params
  })
}
function setStreamPullAddress(params) {
  const url = '/v3/webinars/stream/set-webinar-pull';
  return request({
    url,
    method: 'POST',
    data: params
  })
}
// 设置设备检测状态
function setDevice(params) {
  const url = roomApiList['setDevice']['v3'];
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 获取黄金链路内容
function getLowerGradeConfigInfo(staticDomain, environment, systemKey = 2) {
  const url = `${staticDomain}/fault/${environment}/ops_fault_code_publish_${systemKey}.json`;
  return axios.get(url);
}

// 观看端反馈
function feedbackInfo(params) {
  const url = '/v3/interacts/feedback/user-create-feedback';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 观看端举报
function tipOffInfo(params) {
  const url = '/v3/interacts/report/user-create-report';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 观看端绑定微信分享

function bindShare(params) {
  const url = '/v3/interacts/share/create-share-relation';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// 手机端微信分享信息

function getShareSettingInfo(params) {
  const url = '/v3/webinars/share/info';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

// function wechatShare(params) {
//   const url = '/v3/commons/auth/weixin-share';
//   return request({
//     url,
//     method: 'POST',
//     data: params
//   });
// };

function wwchatShare(params) {
  const url = '/v1/marketing/app/corp-application/get-config-signature';
  return request({
    url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};


// 开始暂停结束打点录制api
function recordApi(data) {
  console.log('录制接口', data);
  return request({
    url: '/v3/webinars/record/ticker',
    method: 'POST',
    data
  });
}

// 直播结束生成回放
function createRecordInLive(data) {
  const url = '/v3/webinars/record/live-create-record';
  return request({
    url,
    method: 'POST',
    data
  });
}

// 设为默认回放
function setDefaultRecord(data) {
  const url = '/v3/webinars/record/set-default';
  return request({
    url,
    method: 'POST',
    data
  });
}

// 录制页面录制完成,生成回放/v3/webinars/record/create
function createRecordInRecord(data) {
  const url = '/v3/webinars/record/create';
  return request({
    url,
    method: 'POST',
    data
  });
}
// 获取直播间流状态
function getLiveStreamStatus(params) {
  const url = '/v3/webinars/stream/get-stream-status';
  return request({
    url,
    method: 'GET',
    params
  });
}

/**
 * @function attention 获取自定义角色名称
 * @params webinar_id: 活动id
*/
const getCustomRoleName = (data) => {
  const url = '/v3/webinars/privilege/get-role-name';
  return request({
    url,
    method: 'POST',
    data
  });
};

/**
 * 获取主题风格详情
 * */
function getSkinsInfo(params = {}) {
  const url = '/v3/interacts/skin/watch-get-webinar-skin';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 更新参会用户的头像和昵称
 * v7.9.3 http://yapi.vhall.domain/project/99/interface/api/56502
 * @param {*} data
 */
function updateJoinInfo(params = {}) {
  const url = roomApiList['updateJoinInfo']['v3'];

  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取观看端回放列表
 * */
function getWatchRecordList(params = {}) {
  const url = '/v3/webinars/record/get-watch-list';
  return request({
    url,
    method: 'GET',
    params
  });
}
/**
 * 获取实时观看数据
 * */
function getRealTimeWatchData(params = {}) {
  const url = '/v3/data-center/live-dashboard-statistics-data';
  return request({
    url,
    method: 'GET',
    params
  });
}

// 获取定时直播推流清晰度列表
function reqGetLivePushDefinitionList(params = {}) {
  const url = '/v3/webinars/live/get-push-definition-list';
  return request({
    url,
    method: 'GET',
    params
  });
}

// 设置定时直播当前推流分辨率
function reqSaveLivePushDefinition(params = {}) {
  const url = '/v3/webinars/live/set-push-definition';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

const meeting = {
  initSendLive,
  initSendLiveYun,
  getStreamStatus,
  selectSeat,
  initStandardReceiveLive,
  clientEmbed,
  initEmbeddedReceiveLive,
  initSdkReceiveLive,
  startLive,
  endLive,
  checkLive,
  getChatInitOptions,
  liveHeartBeat,
  getLiveToken,
  switchBroadcast,
  getStreamPushAddress,
  getStreamPullAddress,
  setStreamPullAddress,
  setDevice,
  getConfigList,
  editConfigList,
  setDurationSwitch,
  getLangList,
  getInavToolStatus,
  getCommonConfig,
  getLowerGradeConfigInfo,
  feedbackInfo,
  tipOffInfo,
  createRecordInLive,
  setDefaultRecord,
  recordApi,
  initRecordVideo,
  startRecord,
  endRecord,
  createRecordInRecord,
  bindShare,
  getShareSettingInfo,
  wechatShare,
  wwchatShare,
  wechatOaSdkSign,
  getCustomRoleName,
  restrictions,
  setUserAgree,
  getLiveStreamStatus,
  startLiveThird,
  getSkinsInfo,
  updateJoinInfo,
  getWatchRecordList,
  getRealTimeWatchData,
  reqGetLivePushDefinitionList,
  reqSaveLivePushDefinition
};

export default meeting;
